export const THUMBNAIL_SIZE = [154, 250];
export const THUMBNAIL_SIZE_LARGE = [240, 400];
export const BORDER_RADIUS = '10px';
export const ICON_SIZE = 40;
export const MOBILE_DRAWER_HEIGHT = 110;
export const MOBILE_DRAWER_HEIGHT_EXPANDED = 410;
export const BACKDROP_BACKGROUND = `
  background: rgba(0, 0, 0, 0.6);
`;
